import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import spanish from '../../../../../../../common/language/spanis';
import english from '../../../../../../../common/language/english';

let lang = spanish;

class Buttons extends Component {
    componentWillMount() {
        const {language}= this.props;
        if (language === 'spanish') {
            lang = spanish;
        }
        else {
            lang = english;
        }
    }
    render() {
        const {owner, phone, email, city, roomType, persons, incomingDate, outcomingDate } = this.props.state;
        return (
            <div>
                <div>
                    <Button
                        variant="outlined"
                        color="secondary"
                        style={{ position: 'absolute', right: 160, bottom: 10, padding:10, width:140 }}
                        onClick={() => this.props.closeModal()}
                    >
                        {lang.form.buttons.close}
                </Button>
                </div>
                <div>
                    <Button
                        variant="outlined"
                        color="primary"
                        disabled={!owner||!phone||!email||!city||!roomType||!persons||!incomingDate||!outcomingDate}
                        style={{ position: 'absolute', right: 10, bottom: 10, padding:10, width:140 }}
                        onClick={() => this.props.submitForm()}
                        >
                        {lang.form.buttons.send}
                    <Icon >send</Icon>
                    </Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    language: state.LanguageReducer.language,
  });
  
  const mapDispatchToProps = dispatch => ({

  });
  
  // make this component available to the app
  export default connect(mapStateToProps, mapDispatchToProps)(Buttons);
  